$(document).ready(function () {
    // import { Modal, Offcanvas } from "bootstrap";

    /**
    |--------------------------------------------------
    | Cookies functions
    |--------------------------------------------------
    */

    const cookiesPrefix = "loba_";

    const createCookie = (value, days) => {
        // If value is an array of cookies from inputs loop and refresh
        // otherwise just refresh the cookie by its name
        if (NodeList.prototype.isPrototypeOf(value)) {
            value.forEach((cookie) => {
                const cookieValue = cookiesPrefix + cookie.value;
                refreshCokkie(cookieValue);
            });
        } else {
            refreshCokkie(value);
        }

        function refreshCokkie(cookieValue) {
            let expires;
            if (days) {
                let date = new Date();
                date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
                expires = "; expires=" + date.toGMTString();
            } else {
                expires = "";
            }

            document.cookie = cookieValue + "=" + true + expires + "; path=/";
        }
    };

    const readCookie = (name) => {
        let nameEQ = name + "="
        let cookies = document.cookie.split(";")
        let readCookie = false
        cookies.forEach((cookie) => {
            while (cookie.startsWith(" ")) {
                cookie = cookie.substring(1, cookie.length)
            }
            if (cookie.startsWith(nameEQ)) {
                readCookie = true
            }
        })
        return readCookie
    };

    const readCookiePermissions = (cookiesRadios) => {
        cookiesRadios.forEach((cookieRadio) => {
            if (readCookie(cookiesPrefix + cookieRadio.value)) {
                const scripts = document.querySelectorAll('script[type="text/plain"][data-assigned-cookie="' + cookieRadio.value + '"]')
                scripts.forEach(script => {
                    const newScript = script.cloneNode(true);
                    newScript.removeAttribute('type');
                    script.parentNode.replaceChild(newScript, script);
                })
                const embeds = document.querySelectorAll('.embed--no-consent[data-assigned-cookie="' + cookieRadio.value + '"]')
                embeds.forEach(embed => {
                    embed.classList.remove('embed--no-consent')
                    const iframe = embed.querySelector('iframe')
                    if (!iframe) return;
                    iframe.src = iframe.dataset.src
                })
            }
        });
    };

    const eraseCookies = () => {
        let cookies = document.cookie.split(";");
        cookies.forEach((cookie) => {
            let cookieName = cookie.replace(' ', '').split("=")[0];
            createCookie(cookieName, -1);
        });
    };

    const initCookiesListener = function (cookiesWrapperSelector, changeCookiesSelector) {
        const cookiesWrapper = document.querySelector(cookiesWrapperSelector),
            changeCookies = document.querySelectorAll(changeCookiesSelector),
            cookiesRadios = document.querySelectorAll('input[name=cookie-radio]'),
            acceptCookiesBtn = document.querySelector('.cookies__accept'),
            denyCookiesBtn = document.querySelector('.cookies__deny'),
            submitCookiesPreferencesBtn = document.querySelector('.cookies__submit'),
            cookiesDescription = document.querySelector('.cookies__description'),
            cookiesSettings = document.querySelector('.cookies__settings'),
            cookiesSettingsLink = document.querySelector('.cookies__settings-link'),
            cookiesCancel = document.querySelector('.cookies__cancel');

        if (!cookiesWrapper) {
            console.log('Cookies Box is missing!')
            return;
        };

        let cookiesModal;
        if (cookiesWrapper.classList.contains('modal')) {
            cookiesModal = $('.cookies__wrapper.modal');
        } else {
            cookiesModal = $('.cookies__wrapper.modal');
        }

        window.dataLayer = window.dataLayer || [];
        function gtag() { dataLayer.push(arguments); }
        window.gtag = gtag;

        if (localStorage.getItem('consentMode') === null) {
            gtag('consent', 'default', {
                'ad_storage': 'denied',
                'ad_user_data': 'denied',
                'ad_personalization': 'denied',
                'analytics_storage': 'denied',
                'personalization_storage': 'denied',
                'functionality_storage': 'denied',
                'security_storage': 'denied'
            })
        } else {
            gtag('consent', 'default', JSON.parse(localStorage.getItem('consentMode')));
        }

        // Show Cookies if not accepted already
        if (!readCookie(cookiesPrefix + "required")) {
            eraseCookies();
            $('body').addClass('modal-open');
            cookiesModal.show();
            $('.cookies__wrapper').addClass('show');
            document.body.style.overflow = "";
            document.body.style.paddingRight = "";
        } else {
            readCookiePermissions(cookiesRadios);
        }

        changeCookies.forEach((button) => {
            button.addEventListener("click", function (e) {
                e.preventDefault();
                eraseCookies();
                cookiesModal.show();
                document.body.style.overflow = "";
                document.body.style.paddingRight = "";
            });
        })

        // Accept all Cookies
        acceptCookiesBtn?.addEventListener("click", function (e) {
            e.preventDefault();
            const cookieVal = document.querySelectorAll('input[name=cookie-radio]');
            submitPreferences(cookieVal);
        });

        // Deny all Cookies (except required)
        denyCookiesBtn?.addEventListener("click", function (e) {
            e.preventDefault();
            const cookieVal = document.querySelectorAll('#cookie-required');
            submitPreferences(cookieVal);
        });

        // Submit preferences
        submitCookiesPreferencesBtn?.addEventListener("click", function (e) {
            e.preventDefault();
            const cookieVal = document.querySelectorAll('input[name=cookie-radio]:checked');
            submitPreferences(cookieVal);
        });

        function submitPreferences(cookieVal) {
            createCookie(cookieVal, 365 * 10);
            readCookiePermissions(cookiesRadios);
            cookiesModal.hide();
            $('.cookies__wrapper').removeClass('show');
            $('body').removeClass('modal-open');
            setConsent();
        }

        // open and close cookies preferences
        cookiesSettingsLink?.addEventListener("click", function (e) {
            e.preventDefault();
            cookiesDescription.classList.toggle('d-none');
            cookiesSettings.classList.toggle('d-none');
        })

        cookiesCancel?.addEventListener("click", function (e) {
            e.preventDefault();
            cookiesDescription.classList.toggle('d-none');
            cookiesSettings.classList.toggle('d-none');
        })
    };

    const setConsent = () => {
        const consentMode = {
            'ad_storage': readCookie(cookiesPrefix + "ad") ? 'granted' : 'denied',
            'ad_user_data': readCookie(cookiesPrefix + "ad") ? 'granted' : 'denied',
            'ad_personalization': readCookie(cookiesPrefix + "ad") ? 'granted' : 'denied',
            'analytics_storage': readCookie(cookiesPrefix + "analytics") ? 'granted' : 'denied',
            'personalization_storage': readCookie(cookiesPrefix + "personalization") ? 'granted' : 'denied',
            'functionality_storage': readCookie(cookiesPrefix + "functionality") ? 'granted' : 'denied',
            'security_storage': readCookie(cookiesPrefix + "security") ? 'granted' : 'denied',
           
        }
        gtag('consent', 'update', consentMode);
        localStorage.setItem('consentMode', JSON.stringify(consentMode));
    }

    initCookiesListener(".cookies__wrapper", ".cookies__change-settings");

    // Quando não tem a função de acordeão/collapse
    $('.accordion-button').on('click', function (e) {
        e.preventDefault();
        const target = $(this).data('bs-target');
        $('.accordion-button').not(this).parent().addClass('collapsed');
        $('.accordion-collapse').not(target).addClass('collapse');
        $(this).parent().toggleClass('collapsed');
        $(target).toggleClass('collapse');
    });

});
